import {
  Component,
  OnInit,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { Client } from '../../../core/types/client';
@Component({
    selector: 'itfg-client-nssi',
    templateUrl: './client-nssi.component.html',
    styleUrls: ['./client-nssi.component.scss'],
    standalone: false
})
export class ClientNssiComponent implements OnChanges, OnInit {
  @Input() client: Client;

  constructor() { }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges): void {
  }

}
